import type { ItemRarity } from '../types/items';

export function getRarityColor(rarity: ItemRarity): string {
  switch (rarity) {
    case 'legendary':
      return 'text-yellow-400';
    case 'epic':
      return 'text-purple-400';
    case 'rare':
      return 'text-blue-400';
    case 'uncommon':
      return 'text-green-400';
    default:
      return 'text-gray-400';
  }
}